import React from 'react';

import { useParams, useLocation } from "react-router-dom"; 

import Grid from '@material-ui/core/Grid';

import FlowEngine from '../FlowEngine/FlowEngine'
import { setFlowTarget, setLanguage } from '../../service/flowengine/FlowEngineAPI';

//import GenericPageComponent from '../GenericPageComponent/GenericPageComponent'
import GenericBreadcrumb from '../GenericBreadcrumb/GenericBreadcrumb'

//import { getFlow } from '../../service/flowengine/FlowEngineAPI';

//import Model3DSingle from '../ModelView/Model3DSingle';
import Model3DICEngineOverview from '../ModelView/Model3DICEngineOverview';


interface BodyProps {
}

// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//

// stateless component resp. functional component

interface ParamTypes {
  page: string
  target: string
}

// export default function Body(props: BodyProps) {
const Body : React.FunctionComponent<BodyProps> = (props) => {
  //// state as hook
  //const [invalid, setInvalid] = useState<Boolean>(false);                // JavaScript "array destructuring": [term1, term2, term3] is translated into 3 single variables "term1", "term2" and "term3"

  // retrieves the url parameter from react-router-dom routing in Body.tsx (ATTENTION: you can use useParams only when the Router is in one of your PARENT components !!!)
  var { page, target } = useParams<ParamTypes>();

  /*
  // ------------------------------
  // get language from url:
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  var ll: string = "en";
  if(query !== null) {
    ll = query.get('lang') || "en";
  }

  if((ll === null) || (ll === "")) {
    console.log("ATTENTION: Query parameter lang missing !!");
    //alert("ATTENTION: Query parameter lang missing !!");
    ll = "en";
  }
  else {
    if(ll !== "en" && ll !== "de")
      ll = "en";
  }
  setLanguage(ll);
  */
 

  // ------------------------------
  // get target from url:
  if((target === null) || (target === "")) {
    console.log("ATTENTION: Query parameter target missing !!");
    alert("ATTENTION: Query parameter target missing !!");

    target = "icengine";
  }

  setFlowTarget(target);


  // target is set, so get language resources and init language system:



  /*
  const helpBox = (<ul>
                      <li>Rotate: mouse left</li>
                      <li>Zoom: mouse wheel</li>
                      <li>Move: mouse right</li>
                  </ul>);
  */

  // initialize target (i.e. the flow to use) from query parameter "target":

  return (
      <Grid container>
        <Grid item xs={12}>
          <GenericBreadcrumb categories={true} pagename={page}></GenericBreadcrumb>
        </Grid>

        {/* Fenstergroesse: s. init() in Model3D !!!
        <Grid item xs={6} >
          <Model3DSingle material="Chrome" model="" pagekey="page1" elementname="Motorauswahl"/>
        </Grid>
        <Grid item xs={6}>
          <Model3DSingle material="Pure chrome" model="" pagekey="page8a" elementname="Pumpentyp"/>
        </Grid>
        */}        

        {/* Fenstergroesse: s. init() in Model3D !!! */}
        <Grid item xs={12}>
          {/* <Model3DICEngineOverview material="Chrome" pagekeydriving="page1a" elementnamedriving="Motorauswahl" pagekeydriven="page1" elementnamedriven="Kombination"/> */}
          <Model3DICEngineOverview material="Chrome" modelnamedriving="Verbrennungsmotor" pagekeydriven="page1" elementnamedriven="Kombination"/>
        </Grid>

        <Grid item xs={12}>
          {/*<GenericPageComponent pagename={page} />*/}
          <GenericBreadcrumb categories={false} pagename={page}></GenericBreadcrumb>
          {/* <FlowEngine target= {target}></FlowEngine> */}
          <FlowEngine target={target}></FlowEngine>
        </Grid>

      </Grid>
  );

}

export default Body;
